import { styled } from '@mui/material/styles'
import { DataGrid, gridClasses } from '@mui/x-data-grid'

export const DataGridCustom = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.columnHeaders}`]: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
  },
  [`& .${gridClasses.row}`]: {
    backgroundColor: theme.palette.grey['50'],
  },
  [`& .${gridClasses.footerContainer}`]: {
    backgroundColor: theme.palette.grey['50'],
  },
  /*[`& .${gridClasses.checkboxInput}`]: {
    color: theme.palette.primary.main,
  },*/
}))
